import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export function useStudents(isAdmin) {
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);

  const fetchStudents = async () => {
    if (!isAdmin) return;

    setLoadingStudents(true);

    const { data: profiles, error } = await supabase
        .from("user_profiles")
        .select("id, user_id, username, full_name, email, role, status, created_at")
        .order("created_at", { ascending: false });

        if (error) {
        console.error("FETCH STUDENTS ERROR:", error);
        alert(error.message);
        setLoadingStudents(false);
        return;
        }

        const userIds = profiles.map((p) => p.user_id);

        const { data: accessRows, error: accessError } = await supabase
            .from("question_bank_access")
            .select(
                "id, user_id, access_type, access_status, access_start_date, access_end_date, access_source, reason, granted_by, created_at"
            )
            .in("user_id", userIds)
            .eq("access_status", "active");

        if (accessError) {
        console.error("FETCH ACCESS ERROR:", accessError);
        }

        const studentsWithAccess = profiles.map((profile) => {
        let activeAccess = (accessRows || []).filter(
            (a) => a.user_id === profile.user_id
            );

            if (activeAccess.some((a) => a.access_type === "all_access")) {
            activeAccess = activeAccess.filter((a) => a.access_type === "all_access");
            }

        return {
            ...profile,
            activeAccess,
        };
        });

        setStudents(studentsWithAccess);

    setLoadingStudents(false);
  };

  const grantAllAccess = async (studentUserId) => {
    const reason = window.prompt("Reason for granting all access?");

    if (!reason) {
        alert("Grant reason is required.");
        return;
    }

    const { data: existingAccess, error: checkError } = await supabase
        .from("question_bank_access")
        .select("id, access_type, access_end_date")
        .eq("user_id", studentUserId)
        .eq("access_type", "all_access")
        .eq("access_status", "active")
        .gte("access_end_date", new Date().toISOString().slice(0, 10));

    if (checkError) {
        alert(checkError.message);
        return;
    }

    if (existingAccess && existingAccess.length > 0) {
        alert("This student already has active all access.");
        return;
    }

    // 加在这里
    await supabase
        .from("question_bank_access")
        .update({
            access_status: "voided",
            voided_at: new Date().toISOString(),
            void_reason: "Replaced by new all_access grant",
        })
        .eq("user_id", studentUserId)
        .eq("access_status", "active");


    const { data: { session } } = await supabase.auth.getSession();

    const { error } = await supabase.from("question_bank_access").insert({
        user_id: studentUserId,
        access_type: "all_access",
        access_start_date: new Date().toISOString().slice(0, 10),
        access_end_date: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 10),
        access_source: "admin_grant",
        access_status: "active",
        reason,
        granted_by: session?.user?.id,
    });

    if (error) {
        alert(error.message);
        return;
    }

    alert("All access granted for 90 days.");
    await fetchStudents();
    };


  const voidAccess = async (accessId) => {
    const reason = window.prompt("Reason for voiding this access?");

    if (!reason) {
        alert("Void reason is required.");
        return;
    }

    const { error } = await supabase
        .from("question_bank_access")
        .update({
        access_status: "voided",
        voided_at: new Date().toISOString(),
        void_reason: reason,
        })
        .eq("id", accessId);

    if (error) {
        alert(error.message);
        return;
    }

    alert("Access voided.");
    await fetchStudents();
    };

  useEffect(() => {
    if (isAdmin) {
        fetchStudents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  return {
    students,
    loadingStudents,
    fetchStudents,
    grantAllAccess,
    voidAccess,
  };
}